import { Base_Url } from '../../BaseUrl/BaseUrl';
import {
  getApiWithAuthorization,
  getApiWithoutAuthorization,
  deleteApiWithAuthorization,
  postApiWithAuthorization,
  putApiWithoutAuthorization,
} from '../ApiMethods/ApiMethods';

const GetDashboardDetailsUrl = `${Base_Url}/get_org_details`;

export const get_org_details = async () => {
  //
  const res = await getApiWithoutAuthorization(GetDashboardDetailsUrl);
  // const res = await Utils.LoginResponse;

  return res;
};
export const get_most_active_students = async filter => {
  //
  const res = await getApiWithoutAuthorization(`${Base_Url}/get_most_active_students?days=${filter}`);
  // const res = await Utils.LoginResponse;

  return res;
};
export const get_org_analytics = async filter => {
  //
  const res = await getApiWithoutAuthorization(`${Base_Url}/get_org_analytics?days=${filter}`);
  // const res = await Utils.LoginResponse;

  return res;
};
export const get_additional_org_info = async filter => {
  //
  const res = await getApiWithoutAuthorization(`${Base_Url}/get_additional_org_info`);
  // const res = await Utils.LoginResponse;

  return res;
};
export const update_org_details = async data => {
  //
  const res = await putApiWithoutAuthorization(`${Base_Url}/update_org_details`, data);
  // const res = await Utils.LoginResponse;

  return res;
};

export const change_password = async data => {
  //
  const res = await putApiWithoutAuthorization(`${Base_Url}/change_password`, data);
  // const res = await Utils.LoginResponse;

  return res;
};
export const upload_org_header_pic = async data => {
  //
  const res = await postApiWithAuthorization(`${Base_Url}/upload_org_header_pic`, data);
  // const res = await Utils.LoginResponse;

  return res;
};
export const upload_org_thumbnail = async data => {
  //
  const res = await postApiWithAuthorization(`${Base_Url}/upload_org_thumbnail`, data);
  // const res = await Utils.LoginResponse;

  return res;
};

export const global_search = async data => {
  //
  const res = await getApiWithAuthorization(`${Base_Url}/search/global?q=${data}`);
  // const res = await Utils.LoginResponse;

  return res;
};
export const get_org_members = async () => {
  const res = await getApiWithAuthorization(`${Base_Url}/org/members`);
  return res;
};

export const add_org_member = async data => {
  const res = await postApiWithAuthorization(`${Base_Url}/org/members`, data);
  return res;
};

export const remove_org_member = async member_id => {
  const res = await deleteApiWithAuthorization(`${Base_Url}/org/members/${member_id}`);
  return res;
};
